import { render, staticRenderFns } from "./SignPanel.vue?vue&type=template&id=1174d0a4&scoped=true"
import script from "./SignPanel.vue?vue&type=script&lang=js"
export * from "./SignPanel.vue?vue&type=script&lang=js"
import style0 from "./SignPanel.vue?vue&type=style&index=0&id=1174d0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1174d0a4",
  null
  
)

export default component.exports